import Chip from "@mui/material/Chip";

// Razões reais gravadas na base (levantamento de 04/08/2026):
// CONTA PROVISÓRIA (~3,8 mil), CONTA DUPLICADA VIDE (~200),
// DUPLICATED EMAIL (~40) e DUPLICATED CPF (~34). A tradução é apenas
// visual — o valor gravado permanece intacto (tooltip mostra o original).
export const orphanReason = (
  reason?: string | null
): { label: string; color: "default" | "primary" | "warning" | "error" } => {
  const value = String(reason || "");
  const upper = value.toUpperCase();
  if (upper.includes("PROVIS"))
    return { label: "Conta provisória", color: "primary" };
  if (upper.includes("VIDE"))
    return { label: "Duplicada (VIDE)", color: "default" };
  if (upper.includes("EMAIL"))
    return { label: "E-mail duplicado", color: "warning" };
  if (upper.includes("CPF")) return { label: "CPF duplicado", color: "error" };
  return { label: value, color: "default" };
};

export const OrphanReasonChip = ({ reason }: { reason?: string | null }) => {
  if (!reason) return null;
  const { label, color } = orphanReason(reason);
  return (
    <Chip
      size="small"
      variant="outlined"
      color={color}
      label={label}
      title={String(reason)}
    />
  );
};

// Matrícula com guarda: a concatenação crua exibia "null-null" quando
// o registro não tinha matrícula (mesma classe de defeito da lista de
// Sócios, já corrigida lá)
export const formatOrphanMatricula = (record: any): string => {
  if (!record?.nMatricula) return "";
  return record.nDigito
    ? `${record.nMatricula}-${record.nDigito}`
    : String(record.nMatricula);
};

// Situação do legado (uma letra) traduzida quando reconhecida
export const orphanSituacao = (value?: string | null): string => {
  const map: Record<string, string> = {
    A: "Ativo",
    C: "Cancelado",
    D: "Sem contato",
    F: "Falecido",
    L: "Licenciado",
  };
  return map[String(value || "").toUpperCase()] || String(value || "");
};
